import { useRepStreaks } from '@/data/hooks/useRepStreaks';
import { useRepPace } from '@/data/hooks/useRepPace';
import { Flame, TrendingUp, AlertTriangle, Trophy } from 'lucide-react';
import { cn } from '@/lib/utils';

type Momentum = { label: string; tone: 'good' | 'warn' | 'bad' | 'great'; icon: typeof Flame };

export function MomentumBadge() {
  const { streaks } = useRepStreaks();
  const pace = useRepPace();

  const behind = pace.some((c) => c.tone === 'bad');
  const ahead = pace.every((c) => c.tone === 'good');

  let m: Momentum;
  if (streaks.current_streak >= 5 && ahead) m = { label: 'Closing Strong', tone: 'great', icon: Trophy };
  else if (streaks.followups_today >= 3 && !behind) m = { label: 'Heating Up', tone: 'good', icon: Flame };
  else if (behind) m = { label: 'At Risk', tone: 'bad', icon: AlertTriangle };
  else m = { label: 'On Pace', tone: 'warn', icon: TrendingUp };

  const Icon = m.icon;
  const tone = {
    great: 'text-purple-300 bg-purple-500/10 border-purple-500/30',
    good: 'text-orange-400 bg-orange-500/10 border-orange-500/20',
    warn: 'text-yellow-400 bg-yellow-500/10 border-yellow-500/20',
    bad: 'text-red-400 bg-red-500/10 border-red-500/20',
  }[m.tone];

  return (
    <div className={cn('inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-semibold', tone)}>
      <Icon className="h-3.5 w-3.5" />
      {m.label}
    </div>
  );
}